import React from "react";
import yingfuwu from "./yingfuwu.jpg";
class hardServicesDetail extends React.Component {
  render() {
    return (
      <div style={{ minHeight: "100vh", background: "#f3f4f5" }}>
        <img src={yingfuwu} style={{ width: "100%" }} />
      </div>
    );
  }
}

export default hardServicesDetail;



// WEBPACK FOOTER //
// ./src/staticPage/hardServices/index.js